import React, { useState } from 'react';
import { Row, Col, Layout } from 'antd';
import { PhoneOutlined, HomeOutlined, MailOutlined } from '@ant-design/icons';

import Dictionary from '../../Dictionary'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect
} from "react-router-dom";

import IstLogo from '../../../assets/images/ift.PNG';
import CerisLogo from '../../../assets/images/ceris.PNG';
import FctLogo from '../../../assets/images/FctLogo.png';

import './index.less';

const { Footer } = Layout;

export default () => {

  return (
    <div className='container'>
      <Row align="middle" gutter={[0, 10]}>
        <Col xs={24} lg={8}>
          <div className="footer-title">
            <h4><Dictionary entry="footer_findUs" oneLine /></h4>
          </div>
          <div className="footer-content">
            <h4>
              <HomeOutlined /> <Dictionary entry="adress_footer" oneLine />
            </h4>
            <p><Dictionary entry="footer_adress" oneLine /></p>
            <h4>
              <PhoneOutlined /> <Dictionary entry="telephone_footer" oneLine />
            </h4>
            <p><Dictionary entry="number_footer" oneLine /></p>
            <h4>
              <MailOutlined /> <Dictionary entry="email_footer" oneLine />
            </h4>
            <p><Dictionary entry="email_value" oneLine /></p>
          </div>
        </Col>
        <Col xs={{ span: 24 }} lg={{ span: 8, offset: 8 }}>
          <Row>
            <Col>
              <div className="title-funding">
                <h4><Dictionary entry="funding_footer" oneLine /></h4>
              </div>
            </Col>
          </Row>
          <Row>
              <Col>
                <a
                  href='https://fct.pt/'
                  target="_blank"
                >
                  <img src={FctLogo} />
                </a>
              </Col>
            </Row>
          <Row>
            <Col>
              <a href='https://tecnico.ulisboa.pt/pt/'
                target="_blank"
              >
                <img src={IstLogo} />
              </a>
            </Col>
          </Row>
          <Row>
            <Col>
              <a href='https://ceris.pt/'
                target="_blank"
              >
                <img src={CerisLogo} />
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );

};
